import { Migration } from "@mydocma/core/src/lib/migration";
import { IDBPDatabase } from "idb";
import { MmProjectDbCollections } from "../../mm-project-db-schema";

export const V12: Migration = {

  up(database: IDBPDatabase<unknown>) {

    const store = database.createObjectStore(MmProjectDbCollections.fault_patches_backup,  { keyPath: 'operation.id' });
    store.createIndex('fUid', 'fUid', { unique: false});
    store.createIndex('gUid', 'gUid', { unique: false})
  },

};
